<template>
  <div :id="'dataTable_'+component.name" v-if="this.component.name != ''">
    <div class="descTable" v-if="component.name !== 'automacaoFiscal'">
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <!-- <h2 style="color:white; margin-left: 1em; "> Consulta de {{component.abrev.length > 0 ? component.abrev : component.text}}</h2> -->
        </v-flex>
      </v-layout>
    </div>

    <div class="descTable" v-if="component.name !== 'automacaoFiscal'">
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <!-- <h2 style="color:white; margin-left: 1em; "> Consulta de {{component.abrev.length > 0 ? component.abrev : component.text}}</h2> -->
        </v-flex>
      </v-layout>
    </div>
    <div v-if="component.name.indexOf('NFe') != -1" class="v-card__text">
    <v-tabs
      v-if="component.name.indexOf('NFe') != -1"
      slider-color="indigo darken-4"
      left
      v-model="currentItem"
      id="containerTab"
      color="grey lighten-5"
    >
      <v-tab
        id="tabOption"
        v-for="(item,i) in tabs"
        :key="i"
        :class="[i == currentItem ? 'active' : '']"
      >{{ item.title }}</v-tab>
      <v-tab-item>
        <div flat v-if="this.currentItem == 0">
          <!-- <v-card-text> -->
            <CommonTable
              :conta="this.conta"
              :alert="this.alert"
              @getNewEmp="getNewEmp($event)"
              @attLogConsulta="attLogConsulta($event)"
              :logConsulta="this.logConsulta"
              :logQtd="this.logQtd"
              :component="this.component"
              :empresa="this.empresa"
              :IBGE="this.IBGE"
            ></CommonTable>
          <!-- </v-card-text> -->
        </div>
      </v-tab-item>
      <v-tab-item>
        <div v-if="this.currentItem == 1">
          <!-- <v-card-text> -->
            <CommonTable
              :conta="this.conta"
              :alert="this.alert"
              @getNewEmp="getNewEmp($event)"
              @attLogConsulta="attLogConsulta($event)"
              :logConsulta="this.logConsulta"
              :logQtd="this.logQtd"
              :component="this.component"
              :empresa="this.empresa"
              :IBGE="this.IBGE"
            ></CommonTable>
          <!-- </v-card-text> -->
        </div>
      </v-tab-item>
      <v-tab-item>
        <div v-if="this.currentItem == 2">
          <!-- <v-card-text> -->
            <CommonTable
              :conta="this.conta"
              :alert="this.alert"
              @getNewEmp="getNewEmp($event)"
              @attLogConsulta="attLogConsulta($event)"
              :logConsulta="this.logConsulta"
              :logQtd="this.logQtd"
              :component="this.component"
              :empresa="this.empresa"
              :IBGE="this.IBGE"
            ></CommonTable>
          <!-- </v-card-text> -->
        </div>
      </v-tab-item>
    </v-tabs>
    </div>
    <div v-if="this.component.name == 'clientes'" class="v-card__text" style="width:90%;margin:auto;">
      <CommonTable
        :conta="this.conta"
        :alert="this.alert"
        v-if="this.component.name == 'clientes'"
        @getNewEmp="getNewEmp($event)"
        @attLogConsulta="attLogConsulta($event)"
        :logConsulta="this.logConsulta"
        :logQtd="this.logQtd"
        :component="this.component"
        :empresa="this.empresa"
        :IBGE="this.IBGE"
      ></CommonTable>
    </div>

    <div v-show="this.component.name == 'fornecedores'" class="v-card__text" style="width:90%;margin:auto;">
      <CommonTable
        :conta="this.conta"
        :alert="this.alert"
        v-if="this.component.name == 'fornecedores'"
        @getNewEmp="getNewEmp($event)"
        @attLogConsulta="attLogConsulta($event)"
        :logConsulta="this.logConsulta"
        :logQtd="this.logQtd"
        :component="this.component"
        :empresa="this.empresa"
        :IBGE="this.IBGE"
      ></CommonTable>
    </div>

    <div v-if="this.component.name == 'produtos'" class="v-card__text">
      <v-tabs
        slider-color="indigo darken-4"
        left
        v-model="currentItemProduto"
        id="containerTab"
        color="grey lighten-5"
      >
        <v-tab
          id="tabOption"
          v-for="(item,i) in tabsProduto"
          :key="i"
          :class="[i == currentItemProduto ? 'active' : '']"
        >{{ item.title }}</v-tab>
        <v-tab-item>
          <div v-if="this.currentItemProduto == 0">
            <!-- <v-card-text> -->
              <CommonTable
                :conta="this.conta"
                :alert="this.alert"
                v-if="this.component.name == 'produtos'"
                @getNewEmp="getNewEmp($event)"
                @attLogConsulta="attLogConsulta($event)"
                :logConsulta="this.logConsulta"
                :logQtd="this.logQtd"
                :component="this.component"
                :empresa="this.empresa"
                :IBGE="this.IBGE"
              ></CommonTable>
            <!-- </v-card-text> -->
          </div>
        </v-tab-item>
        <v-tab-item>
          <div v-if="this.currentItemProduto == 1">
            <!-- <v-card-text> -->
              <CommonTable
                :conta="this.conta"
                :alert="this.alert"
                v-if="this.component.name == 'produtos'"
                @getNewEmp="getNewEmp($event)"
                @attLogConsulta="attLogConsulta($event)"
                :logConsulta="this.logConsulta"
                :logQtd="this.logQtd"
                :component="this.component"
                :empresa="this.empresa"
                :IBGE="this.IBGE"
              ></CommonTable>
            <!-- </v-card-text> -->
          </div>
        </v-tab-item>
      </v-tabs>
    </div>

    <div v-if="this.component.name == 'Iptu'" class="v-card__text">
      <v-tabs
        slider-color="indigo darken-4"
        left
        v-model="currentItemIptu"
        id="containerTab"
        color="grey lighten-5"
      >
        <v-tab
          id="tabOption"
          v-for="(item,i) in tabsIptu"
          :key="i"
          :class="[i == currentItemIptu ? 'active' : '']"
        >{{ item.title }}</v-tab>
        <v-tab-item>
          <div v-if="this.currentItemIptu == 0">
            <!-- <v-card-text> -->
              <CommonTable
                :conta="this.conta"
                :alert="this.alert"
                v-if="this.component.name == 'Iptu'"
                @getNewEmp="getNewEmp($event)"
                @attLogConsulta="attLogConsulta($event)"
                :logConsulta="this.logConsulta"
                :logQtd="this.logQtd"
                :component="this.component"
                :empresa="this.empresa"
                :IBGE="this.IBGE"
              ></CommonTable>
            <!-- </v-card-text> -->
          </div>
        </v-tab-item>
        <v-tab-item>
          <div v-if="this.currentItemProduto == 1">
            <!-- <v-card-text> -->
              <CommonTable
                :conta="this.conta"
                :alert="this.alert"
                v-if="this.component.name == 'Iptu'"
                @getNewEmp="getNewEmp($event)"
                @attLogConsulta="attLogConsulta($event)"
                :logConsulta="this.logConsulta"
                :logQtd="this.logQtd"
                :component="this.component"
                :empresa="this.empresa"
                :IBGE="this.IBGE"
              ></CommonTable>
            <!-- </v-card-text> -->
          </div>
        </v-tab-item>
      </v-tabs>
    </div>

    <div v-if="this.component.name == 'NFSE'" class="v-card__text">
      <v-tabs
        slider-color="indigo darken-4"
        left
        v-model="currentItemNFSE"
        id="containerTab"
        color="grey lighten-5"
      >
        <v-tab
          id="tabOption"
          v-for="(item,i) in tabsNFSE"
          :key="i"
          :class="[i == currentItemNFSE ? 'active' : '']"
        >{{ item.title }}</v-tab>
        </v-tabs>
        <v-tabs-items v-model="currentItemNFSE">
        <v-tab-item>
          <div flat v-if="this.currentItemNFSE == 0">
            <!-- <v-card-text> -->
              <CommonTable
                :conta="this.conta"
                :alert="this.alert"
                v-if="this.component.name == 'NFSE'"
                @getNewEmp="getNewEmp($event)"
                @attLogConsulta="attLogConsulta($event)"
                :logConsulta="this.logConsulta"
                :logQtd="this.logQtd"
                :component="this.component"
                :empresa="this.empresa"
                :IBGE="this.IBGE"
              ></CommonTable>
            <!-- </v-card-text> -->
          </div>
        </v-tab-item>
        <v-tab-item>
          <div flat v-if="this.currentItemNFSE == 1">
            <!-- <v-card-text> -->
              <CommonTable
                :conta="this.conta"
                :alert="this.alert"
                v-if="this.component.name == 'NFSE'"
                @getNewEmp="getNewEmp($event)"
                @attLogConsulta="attLogConsulta($event)"
                :logConsulta="this.logConsulta"
                :logQtd="this.logQtd"
                :component="this.component"
                :empresa="this.empresa"
                :IBGE="this.IBGE"
              ></CommonTable>
            <!-- </v-card-text> -->
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>

    <div v-if="this.component.name == 'CTE'" class="v-card__text">
      <v-tabs
        slider-color="indigo darken-4"
        left
        v-model="currentItemCTE"
        id="containerTab"
        color="grey lighten-5"
      >
        <v-tab
          id="tabOption"
          v-for="(item,i) in tabsCTE"
          :key="i"
          :class="[i == currentItemCTE? 'active' : '']"
        >{{ item.title }}</v-tab>
        </v-tabs>
        <v-tabs-items v-model="currentItemCTE">
        <v-tab-item>
          <div v-if="currentItemCTE == 0">
            <!-- <v-card-text> -->
              <CommonTable
                :conta="this.conta"
                :alert="this.alert"
                v-if="this.component.name == 'CTE'"
                @getNewEmp="getNewEmp($event)"
                @attLogConsulta="attLogConsulta($event)"
                :logConsulta="this.logConsulta"
                :logQtd="this.logQtd"
                :component="this.component"
                :empresa="this.empresa"
                :IBGE="this.IBGE"
              ></CommonTable>
            <!-- </v-card-text> -->
          </div>
        </v-tab-item>
        <v-tab-item>
          <div v-if="currentItemCTE == 1">
            <!-- <v-card-text> -->
              <CommonTable
                :conta="this.conta"
                :alert="this.alert"
                v-if="this.component.name == 'CTE'"
                @getNewEmp="getNewEmp($event)"
                @attLogConsulta="attLogConsulta($event)"
                :logConsulta="this.logConsulta"
                :logQtd="this.logQtd"
                :component="this.component"
                :empresa="this.empresa"
                :IBGE="this.IBGE"
              ></CommonTable>
            <!-- </v-card-text> -->
          </div>
        </v-tab-item>
        </v-tabs-items>
      
    </div>

    <div v-if="this.component.name == 'docsMunicipal'" class="v-card__text">
      <v-tabs
        slider-color="indigo darken-4"
        left
        v-model="currentItemDM"
        id="containerTab"
        color="grey lighten-5"
        style="font-size:0.9em"
      >
        <v-tab
          id="tabOption"
          v-for="(item,i) in tabsDocsMunicipal"
          :key="i"
          :class="[i == currentItem ? 'active' : '']"
        >{{ item.title }}</v-tab>
        <v-tab-item>
          <v-card v-if="this.currentItemDM == 0">
              <DocsFederal 
                :conta="this.conta" 
                :empresa="this.empresa" 
                :alert="this.alert" 
                :IBGE="this.IBGE" 
                :component="this.component"
              />
          </v-card>
        </v-tab-item>
        <!-- <v-tab-item>
          <v-card flat v-if="this.currentItemDM == 1">
              <DocsFederal 
                :conta="this.conta" 
                :empresa="this.empresa" 
                :alert="this.alert" 
                :IBGE="this.IBGE" 
                :component="this.component"
              />
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat v-if="this.currentItemDM == 2">
              <DocsFederal 
                :conta="this.conta" 
                :empresa="this.empresa" 
                :alert="this.alert" 
                :IBGE="this.IBGE" 
                :component="this.component"
              />
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat v-if="this.currentItemDM == 3">
              <DocsFederal 
                :conta="this.conta" 
                :empresa="this.empresa" 
                :alert="this.alert" 
                :IBGE="this.IBGE" 
                :component="this.component"
              />
          </v-card>
        </v-tab-item> -->
      </v-tabs>
    </div>


    <div id="tableEmpresa" style="background:red;">
    <div v-if="this.component.name == 'empresa'" >
      <CommonTable
        :conta="this.conta"
        :alert="this.alert"
        v-if="this.component.name == 'empresa'"
        @emitEditEmp="emitEditEmp($event)"
        @getNewEmp="getNewEmp($event)"
        @attLogConsulta="attLogConsulta($event)"
        @emitAttTable="emitAttTable($event)"
        :attTable="this.attTable"
        :logConsulta="this.logConsulta"
        :logQtd="this.logQtd"
        :component="this.component"
        :empresa="this.empresa"
        :IBGE="this.IBGE"
      ></CommonTable>
      
    </div>
    
      
      
    
    </div>
    <CommonTable
        :conta="this.conta"
        :alert="this.alert"
        v-if="this.component.name == 'automacaoFiscal'"
        @emitEditEmp="emitEditEmp($event)"
        @getNewEmp="getNewEmp($event)"
        @attLogConsulta="attLogConsulta($event)"
        @emitAttTable="emitAttTable($event)"
        :attTable="this.attTable"
        :logConsulta="this.logConsulta"
        :logQtd="this.logQtd"
        :component="this.component"
        :empresa="this.empresa"
        :IBGE="this.IBGE"
      ></CommonTable>
    <CommonTable
      :conta="this.conta"
      :attTable="this.attTable"
      @attTableEmp="attTableEmp($event)"
      :alert="this.alert"
      v-if="this.component.name == 'certificado'"
      @emitEditEmp="emitEditEmp($event)"
      @getNewEmp="getNewEmp($event)"
      @attLogConsulta="attLogConsulta($event)"
      @emitAttTable="emitAttTable($event)"
      :logConsulta="this.logConsulta"
      :logQtd="this.logQtd"
      :component="this.component"
      :empresa="this.empresa"
      :IBGE="this.IBGE"
    ></CommonTable>
    <CommonTable
      :conta="this.conta"
      :attTableEmp="this.attTableEmp"
      @attTableEmp="attTableEmp($event)"
      :alert="this.alert"
      :arrayItems="this.arrayItems"
      v-if="this.component.name == 'usuario'"
      @emitEditEmp="emitEditEmp($event)"
      @getNewEmp="getNewEmp($event)"
      @attLogConsulta="attLogConsulta($event)"
      @emitAttTable="emitAttTable($event)"
      :attTable="this.attTable"
      :logConsulta="this.logConsulta"
      :logQtd="this.logQtd"
      :component="this.component"
      :empresa="this.empresa"
      :IBGE="this.IBGE"
    ></CommonTable>
    <CommonTable
      :conta="this.conta"
      :attTable="this.attTable"
      @attTableEmp="attTableEmp($event)"
      :alert="this.alert"
      v-if="this.component.name == 'conta'"
      @emitEditEmp="emitEditEmp($event)"
      @getNewEmp="getNewEmp($event)"
      @attLogConsulta="attLogConsulta($event)"
      @emitAttTable="emitAttTable($event)"
      :logConsulta="this.logConsulta"
      :logQtd="this.logQtd"
      :component="this.component"
      :empresa="this.empresa"
      :IBGE="this.IBGE"
    ></CommonTable>
    <CommonTable
      :conta="this.conta"
      :attTable="this.attTable"
      @attTableEmp="attTableEmp($event)"
      :alert="this.alert"
      v-if="this.component.name == 'rela_usuario'"
      @emitEditEmp="emitEditEmp($event)"
      @getNewEmp="getNewEmp($event)"
      @attLogConsulta="attLogConsulta($event)"
      @emitAttTable="emitAttTable($event)"
      :logConsulta="this.logConsulta"
      :logQtd="this.logQtd"
      :component="this.component"
      :empresa="this.empresa"
      :IBGE="this.IBGE"
    ></CommonTable>
  </div>
</template>

<script>
import CommonTable from "./commonTable/CommonTable.vue";
import NfeService from "@/domain/notas/nfe/NfeService";
import CteService from "@/domain/notas/cte/CteService";
import NfseService from "@/domain/notas/nfse/NfseService";
import CommonService from "@/domain/dataTable/commonService/CommonService.js";
import Component from "@/domain/dataTable/component/Component.js";
import DocsFederal from '@/pages/loggedArea/docsFederal/DocsFederal';
export default {
  props: [
    "empresa",
    "table",
    "sendAttTable",
    "conta",
    "alert",
    "arrayItems",
    "attTableEmp",
    "IBGE"
  ],
  components: {
    CommonTable: CommonTable,
    DocsFederal: DocsFederal
  },
  data() {
    return {
      component: { name: "", noDataText: "" },
      logConsulta: "",
      logQtd: 1,
      route: this.$router.history.current.path,
      currentItem: 0,
      currentItemProduto: 0,
      currentItemIptu: 0,
      currentItemNFSE: 0,
      currentItemCTE: 0,
      currentItemDF: 0,
      currentItemDM: 0,
      select: {},
      attTable: false,
      attTableCert: false,
      tabs: [
        {
          title: "Recebidas"
        },
        {
          title: "Emitidas"
        },
        {
          title: "Transportadas"
        }
      ],
      tabsProduto: [
        {
          title: "Entrada"
        },
        {
          title: "Saída"
        }
      ],
      tabsIptu: [
        {
          title: "Iptu"
        }
      ],
      tabsNFSE: [
        {
          title: "Recebidas"
        },
        {
          title: "Emitidas"
        }
      ],
      tabsCTE: [
        {
          title: "Tomados"
        },
        {
          title: "Todos"
        }
      ],
      tabsDocsFederal: [
        {
          title: "Situação Fiscal"
        },
        {
          title: "Extrato DCTF"
        },
        {
          title: "Relação de Darfs Pagos"
        },
        {
          title: "E-mails Caixa Postal"
        },
        {
          title: "Processos"
        },
        {
          title: "CND"
        },
      ],
      tabsDocsMunicipal: [
        // {
        //   title: "Relação de NFs"
        // },
        // {
        //   title: "Guias"
        // },
        // {
        //   title: "CND"
        // },
        // {
        //   title: "IPTU"
        // },
      ],
    };
  },
  mounted: function() {
    this.$nextTick(function() {
      this.setComponent();
    });
  },
  attTableEmp(value) {
    if (this.component.name == "certificado") {
      this.attTable = value.ok;
    } else {
      this.$emit("attTableEmp", value);
    }
  },
  watch: {
    "conta.getLog": function(newV, oldV) {
      if (this.conta.getLog) {
        this.logConsulta = "";
        this.logQtd = 1;
        let auxThis = this;
        setTimeout(auxThis.consultaLog(), 2000);
        this.conta.getLog = false;
      }
    },
    sendAttTable: function(newV, oldV) {
      this.attTable = newV;
    },
    $route: function() {
      this.currentItem = 0;
      this.currentItemNFSE = 0;
      this.currentItemCTE = 0;
      this.currentItemProduto = 0;
      this.currentItemIptu = 0;
      this.setComponent();
    },
    currentItem: function() {
      if (this.component.name == "NFeRecebidas") {
        let posTabActive = this.currentItem;
        switch (posTabActive) {
          case 0:
            this.component["tipo"] = "recebida";
            this.component.text = "Nota Fiscal Eletrônica - Recebidas";
            this.component.enable.consultaSefaz = true;
            this.consultaLog();
            break;
          case 1:
            this.component["tipo"] = "emitida";
            this.component.text = "Nota Fiscal Eletrônica - Emitidas";
            this.component.enable.consultaSefaz = false;
            break;
          case 2:
            this.component["tipo"] = "transportados";
            this.component.text = "Nota Fiscal Eletrônica - Transportadas";
            this.component.enable.consultaSefaz = false;
            break;
        }
      }
    },
    currentItemProduto: function() {
      if (this.component.name == "currentItemProduto") {
        let posTabActive = this.currentItemProduto;
        switch (posTabActive) {
          case 0:
            this.component.text = "Produto - Entrada";
            this.component["tipo"] = "recebida";
            break;
          case 1:
            this.component.text = "Produto - Saída";
            this.component["tipo"] = "emitida";

            break;
        }
      }
    },
    currentItemIptu: function() {
      if (this.component.name == "currentItemIptu") {
        let posTabActive = this.currentItemIptu;
        switch (posTabActive) {
          case 0:
            this.component.text = "Iptu";
            this.component["tipo"] = "recebida";
            break;
          case 1:
            this.component.text = "Iptu - Saída";
            this.component["tipo"] = "emitida";

            break;
        }
      }
    },
    currentItemNFSE: function() {
      if (this.component.name == "NFSE") {
        let posTabActive = this.currentItemNFSE;
        switch (posTabActive) {
          case 0:
            this.component.text =
              "Nota Fiscal de Serviço Eletrônica - Recebidas";
            this.component["tipo"] = "recebida";
            this.consultaLog();
            break;
          case 1:
            this.component.text =
              "Nota Fiscal de Serviço Eletrônica - Emitidas";
            this.component["tipo"] = "emitida";
            this.consultaLog();
            break;
        }
      }
    },

    currentItemCTE: function() {
      if (this.component.name === "CTE") {
        let posTabActive = this.currentItemCTE;
        switch (posTabActive) {
          case 0:
            this.component.text =
              "Conhecimento de Transporte Eletrônico - Tomados";
            this.component["tipo"] = "tomados";
            this.consultaLog();
            break;
          case 1:
            this.component.text =
              "Conhecimento de Transporte Eletrônico - Todos";
            this.component["tipo"] = "todos";
            this.consultaLog();
            break;
        }
      }
    },
    currentItemDF: function() {
      if (this.component.name === "docsFederal") {
        let posTabActive = this.currentItemDF;
        switch (posTabActive) {
          case 0:
            this.component.text =
              "Situação Fiscal";
            this.component["tipo"] = "situacao_fiscal";
            break;
          case 1:
            this.component.text =
              "Extrato DCTF";
            this.component["tipo"] = "extrato_dctf";
            break;
          case 2:
            this.component.text =
              "Relação de Darfs Pagos";
            this.component["tipo"] = "relação_de_darfs_pagos";
            break;
          case 3:
            this.component.text =
              "E-mails Caixa Postal";
            this.component["tipo"] = "emails_caixa_postal";
            break;
          case 4:
            this.component.text =
              "Processos";
            this.component["tipo"] = "processos";
            break;
          case 5:
            this.component.text =
              "CND";
            this.component["tipo"] = "cnd";
            break;
        }
      }
    },
    currentItemDM: function() {
      if (this.component.name === "docsMunicipal") {
        let posTabActive = this.currentItemDM;
        switch (posTabActive) {
          case 0:
            this.component.text =
              "Relação de NFs";
            this.component["tipo"] = "relação_de_nfs";
            break;
          case 1:
            this.component.text =
              "Guias";
            this.component["tipo"] = "guias";
            break;
          case 2:
            this.component.text =
              "CND";
            this.component["tipo"] = "cnd";
            break;
          case 3:
            this.component.text =
              "IPTU";
            this.component["tipo"] = "iptu";
            break;
        }
      }
    },
    empresa: function(newV, oldV) {
      //verifica se a empresa mudou para buscar um novo log
      if (newV.cnpj != oldV.cnpj) {
        this.conta.getLog = true;
      }
      this.currentProperties;
    }
  },
  computed: {
    getSelect: function() {},
    currentProperties: function() {
      let obj = {};
      obj["empresa"] = this.empresa;
      return obj;
    }
  },
  methods: {
    consultaLog() {
      if (this.empresa) {
        this.service = new CommonService(this.$http);
        try {
          this.service
            .getLogConsulta(
              this.empresa._id,
              this.component.name,
              this.component.tipo
            )
            .then(res => {
              if (res) {
                this.logConsulta = res.log;
                this.logQtd = res.qtd;
              } else {
                this.logConsulta = "";
                this.logQtd = undefined;
              }
            });
        } catch (e) {
          console.log("NÃO FOI POSSIVEL BUSCAR log");
          console.log(e);
        }
      }
    },
    emitAttTable: function(value) {
      this.attTable = value;
      this.$emit("attSendTable", value);
    },
    setComponent: function() {
      let name = "",
        text = "",
        abrev = "",
        enable = {
          filtrar: true,
          rangeDate: true,
          selectAll: true,
          consultaSefaz: true,
          colunas: true,
          expExcel: true,
          search: true,
          arrowMovTable: true,
          acoes: true,
          verPdf: true,
          downPdf: false,
          downXML: true,
          envEmail: true,
          download: false
        },
        textPlural = "",
        tipo;
      if (this.$router.history.current.path == "/consultaCTe") {
        if (!this.currentItemCTE || this.currentItemCTE === 0) {
          name = "CTE";
          text = "Conhecimento de Transporte Eletrônico - Tomados";
          tipo = "tomados";
        } else {
          name = "CTE";
          text = "Conhecimento de Transporte Eletrônico - Todos";
          tipo = "todos";
        }
        this.getNewEmp(this.empresa);
        abrev = "CT-e";
        textPlural = "CT-e";
        enable.download = true;
        enable.downPdf = true;
      } else if (this.$router.history.current.path == "/consultaNFe") {
        if (this.currentItem == 0) {
          name = "NFeRecebidas";
          tipo = "recebida";
          text = "Nota Fiscal Eletrônica - Recebidas";
        } else if  (this.currentItem == 1){
          name = "NFeRecebidas";
          tipo = "emitida";
          text = "Nota Fiscal Eletrônica - Emitidas";
          enable.consultaSefaz = false;
        }else{
            name = "NFeRecebidas";
            tipo = "transportados";
            text = "Nota Fiscal Eletrônica - Transportadas";
            enable.consultaSefaz = false;
          }
        this.getNewEmp(this.empresa);
        enable.download = true;
        enable.downPdf = true;
        abrev = "NF-e";
        textPlural = "NF-e";
      } else if (this.$router.history.current.path == "/consultaNFSe") {
        if (this.currentItemNFSE == 0) {
          name = "NFSE";
          tipo = "recebida";
          text = "Nota Fiscal de Serviço Eletrônica - Recebidas";
        } else {
          name = "NFSE";
          tipo = "emitida";
          text = "Nota Fiscal de Serviço Eletrônica - Emitidas";
        }
        this.getNewEmp(this.empresa);
        enable.filtrar = true;
        enable.download = true;
        abrev = "NFS-e";
        enable.selectAll = true;
        enable.verPdf = true;
        enable.downPdf = true;
        textPlural = "NFS-e";
      } else if (this.$router.history.current.path == "/fornecedores") {
        enable.selectAll = false;
        enable.verPdf = false;
        enable.downXML = false;
        enable.envEmail = false;
        name = "fornecedores";
        text = "Fornecedor";
        abrev = text;
        textPlural = "Fornecedores";
        enable.filtrar = false;
        enable.consultaSefaz = false;
        enable.rangeDate = false;
      } else if (this.$router.history.current.path == "/clientes") {
        enable.selectAll = false;
        enable.verPdf = false;
        enable.downXML = false;
        enable.envEmail = false;
        name = "clientes";
        text = "Cliente";
        abrev = text;
        textPlural = "Clientes";
        enable.filtrar = false;
        enable.consultaSefaz = false;
        enable.rangeDate = false;
      } else if (this.$router.history.current.path == "/produtos") {
        if (this.currentItemProduto && this.currentItemProduto == 1) {
          tipo = "emitida";
          text = "Produto - Saída";
        } else {
          tipo = "recebida";
          text = "Produto - Entrada";
        }
        this.getNewEmp(this.empresa);
        enable.selectAll = false;
        enable.verPdf = false;
        enable.downXML = false;
        enable.envEmail = false;
        name = "produtos";
        abrev = text;
        textPlural = "Produtos";
        enable.filtrar = false;
        enable.consultaSefaz = false;
        enable.rangeDate = false;
        enable.acoes = false;
      } else if (this.$router.history.current.path == "/consultaIptu") {
 
        tipo = "Iptu";
        text = "Iptu";
  
        this.getNewEmp(this.empresa);
        enable.selectAll = false;
        enable.download = false;
        enable.downIptu = true;
        enable.verPdf = true;
        enable.downXML = false;
        enable.envEmail = false;
        name = "Iptu";
        abrev = text;
        textPlural = "Iptu's";
        enable.filtrar = false;
        enable.consultaSefaz = false;
        enable.rangeDate = false;
        enable.acoes = true;
      } else if (
        this.$router.history.current.path == "/configuracoes" &&
        this.table == "empresa"
      ) {
        enable.verPdf = false;
        enable.downXML = false;
        enable.envEmail = false;
        name = "empresa";
        text = "Empresa";
        abrev = text;
        textPlural = "Empresas";
        enable.filtrar = false;
        enable.consultaSefaz = false;
        enable.rangeDate = false;
        enable.colunas = false;
        enable.selectAll = false;
      } else if (
        this.$router.history.current.path == "/configuracoes" &&
        this.table == "usuario"
      ) {
        enable.verPdf = false;
        enable.downXML = false;
        enable.envEmail = false;
        name = "usuario";
        text = "Colaborador";
        abrev = text;
        textPlural = "Colaboradores";
        enable.filtrar = false;
        enable.consultaSefaz = false;
        enable.rangeDate = false;
        enable.colunas = false;
        enable.selectAll = false;
      } else if (
        this.$router.history.current.path == "/configuracoes" &&
        this.table == "certificado"
      ) {
        enable.verPdf = false;
        enable.downXML = false;
        enable.envEmail = false;
        name = "certificado";
        text = "Certificado";
        abrev = text;
        textPlural = "Certificados";
        enable.filtrar = false;
        enable.consultaSefaz = false;
        enable.rangeDate = false;
        enable.colunas = false;
        enable.selectAll = false;
        enable.acoes = true;
      } else if (
        this.$router.history.current.path == "/configuracoesAutomacao"
      ) {
        enable.verPdf = false;
        enable.downXML = false;
        enable.envEmail = false;
        name = "automacaoFiscal";
        text = "Imóveis";
        abrev = text;
        textPlural = "Imóveis";
        enable.filtrar = false;
        enable.consultaSefaz = false;
        enable.rangeDate = false;
        enable.colunas = false;
        enable.selectAll = false;
        enable.acoes = true;
      } else if (
        this.$router.history.current.path == "/relatorio" &&
        this.table == "conta"
      ) {
        enable.verPdf = false;
        enable.downXML = false;
        enable.envEmail = false;
        name = "conta";
        text = "Conta";
        abrev = text;
        textPlural = "Contas";
        enable.filtrar = true;
        enable.consultaSefaz = false;
        enable.rangeDate = false;
        enable.colunas = false;
        enable.selectAll = true;
        enable.acoes = false;
      } else if (
        this.$router.history.current.path == "/relatorio" &&
        this.table == "rela_usuario"
      ) {
        enable.verPdf = false;
        enable.downXML = false;
        enable.envEmail = false;
        name = "rela_usuario";
        text = "Usuário";
        abrev = text;
        textPlural = "Usuários";
        enable.filtrar = true;
        enable.consultaSefaz = false;
        enable.rangeDate = false;
        enable.colunas = false;
        enable.selectAll = true;
        enable.acoes = false;
     } else if (this.$router.history.current.path == "/docsFederal") {
        name = 'docsFederal';
        if (this.currentItemDF == 0) {
          tipo = "situacao_fiscal";
          text = "Situação Fiscal";
        } else if (this.currentItemDF == 1) {
          tipo = "gnd";
          text = "GND";
        } else {
          tipo = "dctf"
          text = "DCTF"
        }
        this.getNewEmp(this.empresa);
        enable.selectAll = false;
        enable.verPdf = false;
        enable.downXML = false;
        enable.envEmail = false;
        abrev = text;
        enable.filtrar = false;
        enable.consultaSefaz = false;
        enable.rangeDate = false;
        enable.acoes = false;
      } else if (this.$router.history.current.path == "/docsMunicipal") {
        name = 'docsMunicipal';
        if (this.currentItemDM == 0) {
          tipo = "iptu";
          text = "IPTU";
        } else if (this.currentItemDF == 1) {
          tipo = "gnd";
          text = "GND";
        } else {
          tipo = "dctf"
          text = "DCTF"
        }
        this.getNewEmp(this.empresa);
        enable.selectAll = false;
        enable.verPdf = false;
        enable.downXML = false;
        enable.envEmail = false;
        abrev = text;
        enable.filtrar = false;
        enable.consultaSefaz = false;
        enable.rangeDate = false;
        enable.acoes = false;
      }
      this.getNewEmp(this.empresa);
      this.component = new Component(
        name,
        text,
        abrev,
        enable,
        textPlural,
        tipo
      );
      if (this.component.enable.consultaSefaz) {
        this.conta.getLog = true;
      }
    },
    attLogConsulta($event) {
      this.logConsulta = $event;
    },
    getNewEmp: function($event) {
      //onde event é a empresa atual
      this.$emit("getNewEmp", $event);
    },
    emitEditEmp($event) {
      this.$emit("emitEditEmp", $event);
    }
  },

  beforeMount: function() {
    this.$nextTick(function() {});
  }
};

</script>
<!-- Add "scoped" attribute to limit CSS to this component.name only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
a {
  text-decoration: none;
  color: #42b983;
}
.iconCloud {
  transform: rotate(180deg);
}
#panelEmpresa {
  padding: 30px 0;
  background: #e3f2fd;
}
#panelEmpresa h1 {
  font-family: "Quicksand", sans-serif;
}

.v-tabs__bar {
  padding-top: 35px !important;
}
.v-card__text {
  padding: 0!important;
  padding-top: 0 !important;
  width: 90%;
  margin: auto;
}
#tabOption.active {
  background-color: white;
}

.descTable {
  background-color: rgb(0, 150, 136) !important;

  margin: 0 0 39px 0px;
}
.descTable.cte {
  margin: 0 0 50px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/dataTable/RenderTableNFe.vue